import CardsSlider from "./modules/cards-slider";
import Menu from "./modules/menu";
import Search from "./modules/search";
import Select from "./modules/select";
import Toggle from "./modules/toggle";

document.addEventListener("DOMContentLoaded", function () {
   CardsSlider();
   Search();
   Toggle();
   Menu();
   Select();
});

